var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "product-form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.addToCart.apply(null, arguments)
        },
      },
    },
    [
      _vm.isGiftCard
        ? _c(
            "div",
            { staticClass: "product-display__gift-cart" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedGiftCard,
                      expression: "selectedGiftCard",
                    },
                  ],
                  staticClass: "product-display__gift-cart__dropdown",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedGiftCard = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { disabled: "" } }, [
                    _vm._v("Choose Amount"),
                  ]),
                  _vm._l(_vm.variants, function (option) {
                    return _c(
                      "option",
                      { key: option.id, domProps: { value: option.id } },
                      [_vm._v(_vm._s(option.title))]
                    )
                  }),
                ],
                2
              ),
              _c("submit-button", {
                attrs: {
                  label: _vm.buttonLabel,
                  inline: true,
                  disabled: false,
                  isSelected: _vm.isSelected,
                  loading: _vm.adding,
                  full: true,
                },
              }),
            ],
            1
          )
        : _c("div", [
            _c(
              "div",
              { staticClass: "product-form__options" },
              [
                _vm.optionCount > 0 && _vm.variants.length > 1
                  ? _c("product-option", {
                      staticClass: "product-form__variant-selector",
                      class: _vm.option1Label.toLowerCase(),
                      attrs: {
                        option: "option1",
                        label: _vm.option1Label,
                        product: _vm.product,
                        availableOptions: _vm.availableOptions[0],
                        colorsByOption: _vm.getColorsByOption,
                        bundleUrl: _vm.getBundleUrl,
                        bundleMaterial: _vm.getBundleMaterial,
                      },
                      model: {
                        value: _vm.selectedOption1,
                        callback: function ($$v) {
                          _vm.selectedOption1 = $$v
                        },
                        expression: "selectedOption1",
                      },
                    })
                  : _vm._e(),
                _vm.optionCount > 1 && _vm.variants.length > 1
                  ? _c("product-option", {
                      staticClass: "product-form__variant-selector",
                      class: [
                        _vm.option2Label.toLowerCase(),
                        {
                          "u-hidden":
                            _vm.selectedOption2 === "Default Title" ||
                            _vm.selectedOption1 === "NO COLOR" ||
                            _vm.selectedOption1 === "N/A" ||
                            _vm.selectedOption1 === "NS" ||
                            _vm.product.hide_variants,
                        },
                      ],
                      attrs: {
                        option: "option2",
                        label: _vm.option2Label,
                        product: _vm.product,
                        isSelected: _vm.isSelected,
                        availableOptions: _vm.availableOptions[1],
                        colorsByOption: _vm.getColorsByOption,
                        bundleUrl: _vm.getBundleUrl,
                        bundleMaterial: _vm.getBundleMaterial,
                      },
                      on: { "is-selected-false": _vm.isSelectedFalse },
                      model: {
                        value: _vm.selectedOption2,
                        callback: function ($$v) {
                          _vm.selectedOption2 = $$v
                        },
                        expression: "selectedOption2",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "product-form__atc" },
              [
                _c("div", { staticClass: "product-form__price" }, [
                  _vm.comparePrice !== null
                    ? _c("h3", [
                        _c("s", [_vm._v(_vm._s(_vm.comparePrice))]),
                        _c("span", [_vm._v(_vm._s(_vm.currentPrice))]),
                      ])
                    : _c("h3", [_vm._v(_vm._s(_vm.currentPrice))]),
                ]),
                _c("submit-button", {
                  attrs: {
                    label: _vm.buttonLabel,
                    inline: true,
                    disabled: false,
                    isSelected: _vm.isSelected,
                    loading: _vm.adding,
                    full: true,
                  },
                }),
              ],
              1
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }